export const toTitleCase = (
  str: string,
  locale: string = "de-DE"
): string => {
  if (!str || typeof str !== "string") return "";

  return str
    .split(/\s+/) // split on whitespace
    .map(word => {
      if (!word) return "";
      const [first, ...rest] = [...word]; // Unicode-safe spread
      return (
        first.toLocaleUpperCase(locale) +
        rest.join("").toLocaleLowerCase(locale)
      );
    })
    .join(" ");
};
